import React from 'react';

export function ToolbarCard({ icon, label, pressed, onClick, disabled = false, badge, ariaLabel }) {
  const isToggle = typeof pressed === 'boolean' && !disabled;
  return (
    <button
      type="button"
      className="a11y-card"
      aria-pressed={isToggle ? pressed : undefined}
      aria-label={ariaLabel || label}
      data-disabled={disabled || undefined}
      disabled={disabled}
      onClick={disabled ? undefined : onClick}
    >
      <span className="a11y-card__icon" aria-hidden="true">{icon}</span>
      <span className="a11y-card__label">{label}</span>
      {isToggle && pressed && <span className="a11y-card__state" aria-hidden="true"><CheckGlyph /></span>}
      {!isToggle && badge && <span className="a11y-card__badge" aria-hidden="true">{badge}</span>}
    </button>
  );
}

function CheckGlyph() {
  return (
    <svg viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" focusable="false">
      <path d="M4 10l4 4 8-8" />
    </svg>
  );
}

export default ToolbarCard;
